import { render, staticRenderFns } from "./LiveTraining.vue?vue&type=template&id=48856958&scoped=true"
import script from "./LiveTraining.vue?vue&type=script&lang=js"
export * from "./LiveTraining.vue?vue&type=script&lang=js"
import style0 from "./LiveTraining.vue?vue&type=style&index=0&id=48856958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48856958",
  null
  
)

export default component.exports